// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
const config = {
  VUE_APP_AUTH_API: import.meta.env.VITE_APP_AUTH_API,
  VUE_APP_AUTH_ID: import.meta.env.VITE_APP_AUTH_ID,
  VUE_APP_AWS_API: import.meta.env.VITE_APP_AWS_API,
  VUE_APP_ENVIRONMENT: import.meta.env.VITE_APP_ENV,
  VUE_API_WAIT_TIME: 1000,
  VUE_NOTIFICATION_TIMEOUT: 5000,
  VUE_APP_GENERATE_STRING: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
  VUE_LOADER_SPINNER_SIZE: 1.5,
  VUE_CALENDAR_MINIMUM_SELECTED_DAYS: 4,
  VUE_MAX_ORDER_DATE_MONTHS_AHEAD: 6,
  VUE_DEFAULT_LANGUAGE: import.meta.env.VITE_APP_DEFAULT_LANGUAGE || 'sv',
  VUE_DEFAULT_SERVICE: 'admail-postcard',
  VUE_DEFAULT_MARKET: 'SE',
  VUE_DEFAULT_PRODUCT: '6000',
  VUE_DEFAULT_PRICE_UNIT: 'SEK',
  PDF_GUIDE_FILENAME: 'pdf-guide.pdf',
};

export default config;
